module.exports = __webpack_public_path__ + "media/luxury-2026/conyers-family-422d1f9b.jpg";